import React from "react";
import { motion } from "framer-motion";
import { Instagram, Facebook } from "lucide-react";
import { CONTACT } from "../../lib/constants";

export const Social = () => {
  return (
    <section
      id="cardapio"
      className="relative py-20 md:py-24 overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #8a6f24 0%, #C9A84C 45%, #a88931 100%)",
      }}
      data-testid="social-section"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,rgba(255,255,255,0.15),transparent_50%)] pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_70%,rgba(139,0,0,0.18),transparent_50%)] pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-xs tracking-[0.35em] uppercase text-white/85 font-semibold mb-3">
            cardápio & novidades
          </div>
          <h2
            className="font-serif-display text-4xl md:text-5xl text-white font-semibold drop-shadow-md"
            data-testid="social-title"
          >
            Nosso <span className="italic">Cardápio</span> nas Redes
          </h2>
          <p className="mt-5 text-white/90 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Ver cardápio e novidades nas redes sociais.
            Curta, compartilhe e venha nos visitar!
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-10 grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto"
        >
          <a
            href={CONTACT.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="card-hover group flex items-center justify-center gap-3 rounded-2xl px-6 py-5 bg-gradient-to-br from-[#E1306C] via-[#C13584] to-[#833AB4] text-white font-semibold shadow-xl"
            data-testid="social-instagram-cta"
          >
            <Instagram size={26} className="group-hover:scale-110 transition-transform" />
            <span className="text-left">
              <span className="block text-xs opacity-80">Instagram</span>
              <span className="block text-base">@opadrinhorestaurante</span>
            </span>
          </a>

          <a
            href={CONTACT.facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="card-hover group flex items-center justify-center gap-3 rounded-2xl px-6 py-5 bg-[#1877F2] hover:bg-[#0d65d9] text-white font-semibold shadow-xl"
            data-testid="social-facebook-cta"
          >
            <Facebook size={26} fill="currentColor" strokeWidth={0} className="group-hover:scale-110 transition-transform" />
            <span className="text-left">
              <span className="block text-xs opacity-80">Facebook</span>
              <span className="block text-base">O Padrinho Restaurante</span>
            </span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Social;
